import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import Footer from "../components/Footer";
import { Navbar } from "flowbite-react";
import apiClient from "../components/apiClient";
import { useParams } from "react-router-dom";

export const sanitizeHTML = (html) => ({
  __html: DOMPurify.sanitize(html),
});

const BlogDetailpage = () => {
  const { id } = useParams();
  const [detailblogs, setDetailBlogs] = useState([]);

  useEffect(() => {
    const fetchHighlightBlogs = async () => {
      try {
        // const res = await apiClient.get(`/blog/show/highlight/${id}`);
        const res = await apiClient.get(`/blog/show/highlight`);
        console.log("API Response:", res.data); // 🔍 add this
        setDetailBlogs(res.data || []);
      } catch (err) {
        console.error("Failed to fetch blogs:", err);
      }
    };

    fetchHighlightBlogs();
  }, []);

  if (!detailblogs) {
    return <p className="text-center mt-10 text-gray-600">Loading blog...</p>;
  }

  return (
    <>
      <Navbar />
      <div className="p-4 mt-16 flex flex-col order-2 md:order-1">
        {/* <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-800 mb-3 leading-tight">
                  {blog.judul}
                </h1>
                <span className="text-sm md:text-base text-gray-500 mb-2">
                  {new Date(blog.createdAt).toLocaleDateString("id-ID", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </span> */}

        {/* Render rich HTML from blog.detail */}
        <div
          className="ck-content whitespace-pre-wrap text-gray-700"
          dangerouslySetInnerHTML={sanitizeHTML(
            detailblogs.detail || "No description available."
          )}
        />
      </div>

      <Footer />
    </>
  );
};
export default BlogDetailpage;
